import React from 'react'
import EasingMotion from './easing-motion'
import { spring } from 'react-motion'
import colors from '../colors'
import { guardProps } from './validate'

import { AXIS_DIAGONAL, FONT_LARGE, FONT_FAMILY, SPRING } from '../constants'

class EasingTick extends React.PureComponent {
  static defaultProps = {
    x: 0,
    y: 0,
    align: 'end',
    baseline: 'mathematical',
    rotation: AXIS_DIAGONAL,
    fontSize: FONT_LARGE,
    fontFamily: FONT_FAMILY,
    fontStyle: 'italic',
    fill: colors.label
  }

  renderTick({ x, y }) {
    const transform = `translate(${x || 0},${y || 0}) rotate(-${
      this.props.rotation
    })`

    return (
      <text className="axis__tick" transform={transform}>
        {this.props.label}
      </text>
    )
  }

  render() {
    const {
      x,
      y,
      align,
      fill,
      fontSize,
      fontFamily,
      fontStyle,
      opacity,
      baseline,
      className
    } = this.props

    if (guardProps(this, 'x', 'y')) {
      return null
    }

    const style = {
      x: spring(x, SPRING),
      y: spring(y, SPRING)
    }

    return (
      <g
        className={className}
        fontFamily={fontFamily}
        fontSize={fontSize}
        fontStyle={fontStyle}
        textAnchor={align}
        dominantBaseline={baseline}
        fill={fill}
        opacity={opacity}
      >
        <EasingMotion style={style} static={this.props}>
          {style => this.renderTick(style)}
        </EasingMotion>
      </g>
    )
  }
}

export default EasingTick



// WEBPACK FOOTER //
// /home/runner/work/web-interactive/web-interactive/lib/components/charts/shapes/easing-vertical-tick.js